import styled, { withTheme } from 'styled-components';
import { motion } from 'framer-motion';

const SSkillsSet = styled(({ ...rest }) => <motion.div {...rest} />)`
  ${(props) => props.theme.layout.wrapperMobile};
  ${(props) => props.theme.layout.routeMotion};
  height: 100vh;
  background: white;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    ${(props) => props.theme.layout.wrapper};
  }
`;

const SHeader = withTheme(styled.header`
  ${(props) => props.theme.layout.header};
  margin: ${(props) => props.theme.spacing.rem(0, 0, 3)};
`);

const SIntro = withTheme(styled.div`
  margin: ${(props) => props.theme.spacing.rem(3, 0)};
`);

export { SSkillsSet, SHeader, SIntro };
